import Requester from "./Requester";
// import jwtDecode from 'jwt-decode';
import dayjs from 'dayjs';

type CookieOptions = {
    maxAge?: number;              // В секундах
    expires?: Date;               // Дата истечения
    path?: string;                // Путь (по умолчанию '/')
    domain?: string;              // Домен
    secure?: boolean;             // Secure-флаг
    sameSite?: 'Lax' | 'Strict' | 'None'; // SameSite policy
};

const CookieManager = {
    set: (name, value, options: CookieOptions = {}) => {
        let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

        if (options.maxAge) {
            cookieStr += `; max-age=${options.maxAge}`;
        }

        if (options.expires) {
            cookieStr += `; expires=${options.expires.toUTCString()}`;
        }

        if (options.path) {
            cookieStr += `; path=${options.path}`;
        } else {
            cookieStr += `; path=/`;
        }

        if (options.domain) {
            cookieStr += `; domain=${options.domain}`;
        }

        if (options.secure) {
            cookieStr += `; Secure`;
        }

        if (options.sameSite) {
            cookieStr += `; SameSite=${options.sameSite}`;
        }

        document.cookie = cookieStr;
    },

    get: (name) => {
        const cookies = document.cookie.split(';').reduce((acc, curr) => {
            const [key, val] = curr.trim().split('=');
            acc[decodeURIComponent(key)] = decodeURIComponent(val);
            return acc;
        }, {});
        return cookies[name] || null;
    },

    delete: (name, path = '/') => {
        document.cookie = `${encodeURIComponent(name)}=; path=${path}; max-age=0`;
    }
};


export function login(data) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/login`), data)
}

export function me() {
    const requester = new Requester();

    return requester.get(requester.getUrl(`api/me`))
}



export function setToken(token, expires) {
    localStorage.setItem('token', token);
    localStorage.setItem("token_exp", expires);

    CookieManager.set('token', token, { maxAge: 604800, secure: true, sameSite: 'Lax', domain: 'pricehunt.ca' });
}


export function getToken() {
    return localStorage.getItem("token");
}

export function clearToken() {
    localStorage.removeItem("token");
    localStorage.removeItem("token_exp");
}

export function setTokenExp(exp) {
    localStorage.setItem("token_exp", exp);
}
export function getTokenExp() {
    const value = localStorage.getItem("token_exp");

    return value ? parseInt(value) : 0;
}

export function checkAuth() {
    if (getToken() === null) {
        return false;
    } else if (getTokenExp() !== null) {
        let date = dayjs();
        let now = date.unix();
        if (getTokenExp() - now > 0) {
            return true
        } else {
            clearToken();
            return false;
        }
    } else {
        return true
    }
}

export function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("token_exp");
    window.location.reload();
}


export default {
    login,
    setToken,
    getToken,
    clearToken,
    checkAuth,
    logout,
    me
}